import { isAnnual } from "@/react/helpers/planHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { useUpgradePlanContext } from "../UpgradePlanContext";
import { isDowngrade } from "../planActionHelpers";

const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

export const useBlockEnterpriseDowngrade = () => {
  const { plan } = useUpgradePlanContext();

  const {
    isCommunityOnEnterprise,
    isCommunityOnPaidPlan,
    currentPeriodEnd,
    currentPlanInterval,
  } = usePlanStatus();

  const isEnterpriseAnnual =
    isCommunityOnEnterprise && isAnnual(currentPlanInterval);

  const isSubscriptionEndingInMoreThan30Days =
    currentPeriodEnd &&
    new Date(currentPeriodEnd).getTime() >
      new Date(Date.now() + THIRTY_DAYS).getTime();

  const shouldBlockEnterpriseDowngrade =
    isEnterpriseAnnual &&
    isCommunityOnPaidPlan &&
    isDowngrade(plan.plan_action) &&
    isSubscriptionEndingInMoreThan30Days;

  return { shouldBlockEnterpriseDowngrade };
};
